import React, { useMemo } from "react";
import CloseBtn from "../CloseBtn";
import { Button, Form, Modal, Spinner, Table } from "react-bootstrap";
import SimpleTable from "../../comman/custom-table/SimpleTable";

const ImportModal = ({
  show,
  onHide,
  loading,
  importSuccess,
  importReport,
  importing,
  onExit,
  onImport,
  downloadValidationErrorsCsv,
}) => {
  const rows = useMemo(
    () =>
      (importReport?.errors ?? []).map((e, i) => ({
        _sr: i + 1,
        row: e?.row,
        errors: e?.errors ?? [],
        raw: e?.data ?? {},
      })),
    [importReport]
  );

  const columns = useMemo(
    () => [
      {
        header: "Sr.",
        accessor: "_sr",
        id: "sr",
        minWidth: 60,
        sortType: "number",
        className: "text-nowrap text-center fw-semibold",
      },
      {
        header: "Row",
        accessor: "row",
        id: "row",
        minWidth: 80,
        sortType: "number",
        className: "text-nowrap text-center fw-semibold",
      },
      {
        header: "Errors",
        accessor: "errors",
        id: "errors",
        sortable: false,
        minWidth: 320,
        className: "fw-semibold",
        cell: (value) => (
          <ul className="mb-0 ps-3">
            {(value ?? []).map((msg, idx) => (
              <li key={idx}>{String(msg)}</li>
            ))}
          </ul>
        ),
      },
      {
        header: "Data (original)",
        accessor: "raw",
        id: "raw",
        sortable: false,
        minWidth: 420,
        className: "fw-semibold small",
        cell: (value) => (
          <code className="small">{JSON.stringify(value ?? {}, null, 0)}</code>
        ),
      },
    ],
    []
  );
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={importSuccess && importReport ? "xl" : "md"}
      backdrop={importing ? "static" : true} // don't allow closing
      keyboard={!importing}
    >
      {!importing && <CloseBtn onClick={onHide} color="#bf352b" />}

      <Modal.Header>
        <Modal.Title>Import Sleeves from Excel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {importing ? (
          // 🔄 Loading view
          <div className="text-center my-4">
            <Spinner animation="border" role="status" />
            <div className="mt-2">Importing… please wait</div>
          </div>
        ) : (
          <>
            {importSuccess === null && (
              <Form.Group className="mb-3">
                <Form.Label>Select .xlsx/.xls file</Form.Label>
                <Form.Control
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={onImport}
                />
                <div className="text-muted small">
                  Ensure the file matches the required headers. The import will
                  upsert using a unique key (e.g., sleeve_code or name—depending
                  on your backend).
                </div>
              </Form.Group>
            )}

            {importSuccess === true && importReport && (
              <div className="d-grid columns-2 columns-md-4 gap-3">
                <div className=" p-2 border rounded text-center bg-light">
                  <strong>Total:</strong> {importReport?.totalRows ?? 0}
                </div>

                <div className=" p-2 border rounded text-center bg-light">
                  <strong>Created:</strong> {importReport?.createdCount ?? 0}
                </div>

                <div className=" p-2 border rounded text-center bg-light">
                  <strong>Updated:</strong> {importReport?.updatedCount ?? 0}
                </div>

                <div className=" p-2 border rounded text-center bg-light">
                  <strong>Errors:</strong> {importReport?.errorCount ?? 0}
                </div>
              </div>
            )}

            {importSuccess === false && importReport && (
              <>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">
                    {(importReport?.createdCount ?? 0) +
                      (importReport?.updatedCount ?? 0) >
                    0
                      ? "Imported with errors"
                      : "Validation Errors"}
                  </h6>
                  {importReport?.errors?.length > 0 && (
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => downloadValidationErrorsCsv(importReport)}
                    >
                      Download errors (.csv)
                    </Button>
                  )}
                </div>

                {/* <Table bordered responsive size="sm">
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>Row</th>
                        <th>Errors</th>
                        <th>Data (original)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importReport?.errors?.map((error, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{error.row}</td>
                          <td>
                            <ul className="mb-0 ps-3">
                              {error.errors?.map((msg, idx) => (
                                <li key={idx}>{msg}</li>
                              ))}
                            </ul>
                          </td>
                          <td>
                            <code className="small">
                              {JSON.stringify(error.data, null, 0)}
                            </code>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table> */}

                <SimpleTable
                  data={rows}
                  columns={columns}
                  loading={loading}
                  keyField="_sr"
                  responsive
                  emptyMessage="No import errors found"
                  size="sm"
                />
              </>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {importing ? (
          <Button variant="secondary" disabled>
            <Spinner animation="border" size="sm" className="me-2" />
            Importing…
          </Button>
        ) : importSuccess === null ? (
          <Button variant="secondary" onClick={onExit}>
            Close
          </Button>
        ) : (
          <Button variant="outline-secondary" onClick={onExit}>
            Done
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ImportModal;
